import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEOHeadTags = () => {
  const location = useLocation();

  useEffect(() => {
    // Set canonical URL
    const canonicalUrl = `${window.location.origin}${location.pathname}`;
    let canonicalLink = document.querySelector("link[rel='canonical']");
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    // Set robots meta tag
    let robotsMeta = document.querySelector("meta[name='robots']");
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'index,follow');

  }, [location]);

  return null; // This component doesn't render anything in the UI
};

export default SEOHeadTags;
